import {z} from 'zod'
import {ICalEventId} from './ICalEventId.js'
import {DateRange} from '../dateRange/index.js'

export const ICalEvent = z.intersection(
  z.object({
    userId: z.string(),
    id: ICalEventId,
    uid: z.string(),
    summary: z.string(),
    connectionId: z.string(),
    creationTime: z.iso.datetime(),
    updateTime: z.iso.datetime().nullish(),
    handledTime: z.iso.datetime().nullish(),
  }),
  DateRange,
)
export type ICalEvent = z.infer<typeof ICalEvent>
